import { ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { CloseButton } from '~/components/ui/CloseButton';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Backdrop, Header, Panel, Screenshot } from './Screen.styled';

function Screen() {
	const screenshot = useObservable(rage.admin.getScreenshot());

	return (
		<Backdrop>
			<Panel aria-label="Снимок экрана игрока">
				<Header>
					<Text>Снимок экрана игрока</Text>
					<CloseButton
						height={ButtonHeight.Height30}
						iconSize={14}
						color={ButtonColors.Default}
						onClick={() => rage.admin.closeScreenshot()}
					/>
				</Header>
				{screenshot && (
					<Screenshot src={screenshot} alt="Снимок экрана игрока" />
				)}
			</Panel>
		</Backdrop>
	);
}

export default new LayoutBuilder(Screen).setDisplayName(Layouts.Screen).build();
